// extracted by mini-css-extract-plugin
export default {"list":"OrderList_list__ShXPX","listContainer":"OrderList_listContainer__yX06O"};